<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <mat-tab-group>
    <mat-tab label="Create">
      <p>{{data.message}}</p>
      <form [formGroup]="dosageTypeForm">
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Unit</mat-label>
            <mat-select required formControlName="dosageUnit">
              @for (unit of dosageUnits; track unit) {
                <mat-option [value]="unit">
                  {{unit.unit}}
                </mat-option>
              }
            </mat-select>
            <button type="button" matSuffix mat-icon-button (click)="createDosageUnit($event)">
              <mat-icon>add</mat-icon>
            </button>
            @if (dosageTypeForm.get('dosageUnit')?.invalid) {
              <mat-error>
                Dosage unit is invalid
              </mat-error>
            }
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Dosage type</mat-label>
            <input required formControlName="type" type="text" matInput placeholder="Dosage type">
            @if (dosageTypeForm.get('type')?.invalid) {
              <mat-error>
                Dosage type is invalid
              </mat-error>
            }
          </mat-form-field>
        </p>
        <p>
          <mat-form-field appearance="outline">
            <mat-label>Code</mat-label>
            <input required formControlName="code" type="text" matInput placeholder="Code">
            @if (dosageTypeForm.get('code')?.invalid) {
              <mat-error>
                Code is invalid
              </mat-error>
            }
          </mat-form-field>
        </p>
      </form>
    </mat-tab>
    <mat-tab label="Manage units">
      @for (unit of dosageUnits; track unit) {
        <div class="mt-2">
          <div class="row">
            <p class="col-md-8">{{unit.unit}}</p>
            <p class="col-md-4 text-end">
              <button (click)="deleteDosageUnit(unit)" mat-flat-button color="warn">Delete</button>
            </p>
          </div>
          <div class="py-2">
            <mat-divider></mat-divider>
          </div>
        </div>
      }
    </mat-tab>
  </mat-tab-group>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button [mat-dialog-close]="false">Cancel</button>
  <button [disabled]="!dosageTypeForm.valid" mat-raised-button  color="primary" (click)="createDosageType()">Create</button>
</div>
